import { Theme } from "@costar/theme-ui";
export default {
    legacy: {
        borderRadius: "none",
        boxShadow: "primaryRise",
        elevation: 300,
    },
} as Theme;
